import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { SpinnerConstructor } from '../../../../shared/components';
import CampoDadosAcervo from './CampoDadosAcervo';
import ErrorPage from '../ErrorPage';
import CampoDadosArquivo from './CampoDadosArquivo';

const DadosAcervoPrincipal = props => {
    const { viewModeBiblioteca = false } = props;
    const getContent = () => {
        switch (props.dados.tipo_acervo) {
            case 'B':
                return (
                    <Row className="pad5 animated fadeIn">
                        <Col xs="12" md="12">
                            {props.dados.campos.map(campo => {
                                return (
                                    <CampoDadosAcervo
                                        viewModeBiblioteca={viewModeBiblioteca}
                                        key={`field__${campo.ordem}`}
                                        campo={campo}
                                        codAcervo={props.codAcervo}
                                    />
                                );
                            })}
                        </Col>
                    </Row>
                );
            case 'M':
                return (
                    <Row className="pad5 animated fadeIn">
                        <Col xs="12" md="12">
                            {props.dados.campos.map((campo, index) => {
                                return (
                                    <CampoDadosArquivo
                                        key={`field__${index}`}
                                        campo={campo}
                                        codAcervo={props.codAcervo}
                                    />
                                );
                            })}
                        </Col>
                    </Row>
                );
            case 'A':
                return (
                    <Row className="pad5 animated fadeIn">
                        <Col xs="12" md="12">
                            {props.dados.campos.map((campo, index) => {
                                return (
                                    <CampoDadosArquivo
                                        key={`field__${index}`}
                                        campo={campo}
                                        codAcervo={props.codAcervo}
                                    />
                                );
                            })}
                        </Col>
                    </Row>
                );
            default:
                return <div />;
        }
    };

    return props.dados ? (
        !props.dados.error ? (
            getContent()
        ) : (
            <ErrorPage msg={props.dados.message} />
        )
    ) : (
        <div className="text-center p-5">
            <SpinnerConstructor
                visible
                className="s20 cortxt70"
                height={100}
                width={100}
                showLabel
            />
        </div>
    );
};

DadosAcervoPrincipal.propTypes = {
    dados: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
    viewModeBiblioteca: PropTypes.bool,
};

export default DadosAcervoPrincipal;
